<template>
  <div v-if="showItem">
  <!-- TODO: Inserire combobox: Attenzione errore non visualizza la descrizione ma il codice!! -->
    <v-autocomplete
      :disabled="disabled"
      :readonly="readonly || item.readonly"
      :items="elementiSorted"
      item-text="descrizione"
      item-value="codice"
      :value="item.value"
      :label="item.label"
      :rules="rulesValidation"
      :return-object="true"
      :clearable="!readonly && !item.readonly && !disabled && !disableClear" 
      dense
      hide-details="auto"
      :solo="suTable"
      :flat="suTable"
      :outlined="!suTable"
      :background-color="backColor"
      @change="onChange"
      @click:clear="onClear"
      @focus="onFocus"
      @blur="onBlur"
      :ref="item.model"
    >
      <template v-slot:append-outer>
        <v-icon v-if="!item.addForbidden" color="info" @click="onAddEvent">mdi-playlist-plus</v-icon>
      </template>
<!--       <template v-slot:prepend>
        <span v-if="item.required" class="red--text">*</span>
      </template>   -->  
    </v-autocomplete>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{dialogTitle}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formAdd" v-model="formAddFieldsValid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6" md="5">
                  <v-text-field v-model="codice" label="Codice" autofocus :rules="rulesValidationAddCode"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="7">
                  <v-text-field v-model="descrizione" label="Descrizione" :rules="rulesValidationAddDescription"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="annullaNuovo">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click="salvaNuovo">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  // import { dynamicSortMultiple } from '@/components/helpers.js'
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService.js'
  import { validazioni } from '@/mixins/validazioni.js'

  export default {
    name: 'multiselect',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      updateTrigger: Number,
      suTable: { type: Boolean, default: false },
      index: Number,
      disableClear: { type: Boolean, default: false },
      backColor: { type: String, default: 'transparent' }
    },
    data: (vm) => ({
      elementi: [],
      sourceArray: [],
      dialog: false,
      codice: '',
      descrizione: '',
      valoreInserito: '',
      oldValue: '',
      formAddFieldsValid: true
    }),
    async mounted() {
      if (typeof this.item.source === 'string') {
        const config = this.item.source.split('.')
        const configId = config[0]
        const subId = config[1] || ''
        const sub2 = config[2] || ''
        this.sourceArray = await configurazioni.getConfigurazione(configId, subId)
        if (sub2) {
          let el = this.sourceArray ? this.sourceArray.filter(x => x.tipo === sub2) : []
          const ordinato = _.some(el, 'ordine')
          el = _.sortBy(el, ordinato ? ['ordine'] : ['descrizione'])

          this.elementi = el.map(x => { return { codice: x.codice, descrizione: x.descrizione } })
          // this.elementi = this.sourceArray ? this.sourceArray.filter(x => x.tipo === sub2).map(x => { return { codice: x.codice, descrizione: x.descrizione } }) : []
        } else {
          let el = this.sourceArray ? this.sourceArray : []
          const ordinato = _.some(el, 'ordine')
          el = _.sortBy(el, ordinato ? ['ordine'] : ['descrizione'])
          this.elementi = el
          // this.elementi = this.sourceArray ? this.sourceArray/* .map(x => { return { codice: x.codice, descrizione: x.descrizione } }) */ : []
        }
      } else if (Array.isArray(this.item.source)) {
        // TODO: Verificare con caso reale
        this.elementi = [...this.item.source]
      }
      if (this.item.exclude && this.item.exclude.length > 0) {
        for (let e of this.item.exclude) {
          this.elementi = this.elementi.filter(x => !this.item.exclude.includes(x.tipoDocumento))
        }
      }      
    },
    watch:{
      updateTrigger() {
        this.$forceUpdate()
      }
    },
    computed: {
      showItem() {
        if (this.item && this.item.showIf) {
          return _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      },
      elementiSorted() {
/*         const els = this.elementi
        const elSorted = els.sort(dynamicSortMultiple('descrizione')) */
        return this.elementi
      },
      dialogTitle() {
        return 'Nuovo valore ' + this.item.label
      },
      rulesValidationAddCode() { // TODO: prendere da DB su elemento ?
        let rl = []
        rl.push(this.rules.required)
        rl.push(this.rules.nospaces)
        rl.push(this.rules.setristretto)
        return rl
      },
      rulesValidationAddDescription() { // TODO: prendere da DB su elemento ?
        let rl = []
        rl.push(this.rules.required)
        return rl
      }      
    },
    methods: {
      onFocus(e) {
        this.oldValue = e.currentTarget.value
      },
      onBlur(e) {
        this.valoreInserito = e.currentTarget.value
        if (this.valoreInserito !== this.oldValue) {
          this.onChange(null, this.valoreInserito)
        }
      },
      onChange(item, descrizione) {
        if (item) {
          this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: item, index: this.index })
          this.oldValue = item.descrizione
        } else if (descrizione && descrizione.length > 0 && !this.item.addForbidden) {
          this.addElement(descrizione)
        }
      },
      onClear() {
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: null })
        this.oldValue = ''
      }, 
      onAddEvent() {
        this.addElement()
      },
      addElement(value) {
        // let digitato = this.valoreInserito
        this.codice = ''
        this.descrizione = value
        this.dialog = true
      },
      annullaNuovo() {
        this.$refs.formAdd.reset()
        this.dialog = false
      },
      async salvaNuovo() {
        const valid = this.$refs.formAdd.validate()
        if (valid) {
          this.dialog = false
          if (typeof this.item.source === 'string') {
            const config = this.item.source.split('.')
            const configId = config[0]
            const subId = config[1] || ''
            const sub2 = config[2] || ''
            let item = { codice: this.codice, descrizione: this.descrizione, ordine: 0 }
            if (sub2) {
              item.tipo = sub2
            }
            await configurazioni.aggiornaCategorie(configId, subId, [item])

            this.elementi.push(item)
            this.item.value = this.codice
            this.onChange({ codice: this.codice, descrizione: this.descrizione })
          }
        }
      }
    }
  }
</script>

